function isLoading(state = false, action) {
  switch (action.type) {
    case "LOGGING_IN":
      return true;
    case "GET_JOBS":
      return true;
    case "GET_WORKORDERS":
      return true;
    case "GET_DETAILS":
      return true;
    case "LOGIN_MESSAGE":
      return false;
    case "RECEIVE_JOBS":
      return false;
    case "RECEIVE_WORKORDERS":
      return false;
    case "RECEIVE_DETAILS":
      return false;
    case "STOP_LOADING":
      return false;
    case "@@router/LOCATION_CHANGE":
      return true;
    case "GET_COMPANIES":
      return true;
    default:
      return state;
  }
  return state;
}

export default isLoading;



// WEBPACK FOOTER //
// ./app/reducers/isLoading.js